// extracted by mini-css-extract-plugin
export default {"monitorCard":"styles_monitorCard__u7Lx6","iconButton":"styles_iconButton__OfHU9"};